import React from 'react';
import BgImg from '../basicComponents/BgImg';
import SimpleButton from '../basicComponents/SimpleButton';
import { moment } from '../../../containers/App';
import { getText } from '../../utils/functions';
import { MainAppContext } from '../../MainAppContext';

/**
 * Constant values for complex styling props
 */
const defaultClassTEXTS = {
	classNameDIV: 'w-full md:w-1/2 flex flex-col items-center gap-y-4',
	classNameDATE: 'font-black text-center text-2xl md:text-5xl',
	classNameNAME: 'font-light text-center text-2xl md:text-3xl',
};
const defaultClassBTN = {
	classNameDIV: 'w-full flex flex-col justify-center md:w-max',
	classNameBTN: 'w-full md:px-10 md:py-4 px-9 py-6 rounded-lg',
	classNameTXT: 'text-xl md:text-xl ',
};
const defaultClassBTNOption = {
	classNameBTN: 'w-full focus:outline-none flex justify-around md:hidden rounded-sm px-9 py-2',
	classNameTXT: 'text-base',
};
function Showcase({
	data,
	portal,
	bgImg,
	colors,
	setRouting = () => {},
	translate,

	/* OPTIONAL PROPS */
	classNameDIV = `max-w-screen-2xl font-lato flex gap-y-4 pb-10 md:pb-24 md:pt-32
	flex-col pt-24 px-5 items-center
		md:flex-row md:px-9 md:justify-around md:mx-auto align-middle`,
	styleDIV,
	classNameTEXTS,
	classNameBTN,
	styleBTN,
}) {
	/* Main App Context */
	const { setOpenMobileMenu } = React.useContext(MainAppContext);

	/* Default values for the styles */
	const defaultStyleDIV = {
		color: colors?.secondary,
	};
	const defaultStyleBTN = {
		border: `2px solid ${colors?.secondary}`,
		color: colors?.secondary,
		transition: 'all 200ms ease-in',
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyleDIV = { ...defaultStyleDIV, ...styleDIV };
	const overrideStyleBTN = { ...defaultStyleBTN, ...styleBTN };
	const overrideClassNameBTN = { ...defaultClassBTN, ...classNameBTN };
	const overrideClassNameTEXTS = { ...defaultClassTEXTS, ...classNameTEXTS };

	return <BgImg
		img={bgImg}
		color={colors?.primary}
	>
		<div
			id='Showcase'
			className={classNameDIV}
			style={overrideStyleDIV}
		>
			{/* TEXTS */}
			<div className={overrideClassNameTEXTS.classNameDIV}>
				<span className={overrideClassNameTEXTS.classNameDATE}>
					{
						(data?.title?.isActive && getText(data?.title, translate))
						|| moment(portal?.council?.dateStart)?.locale(translate.currentLanguage)?.format(data?.dateFormat)
					}
				</span>
				<span className={overrideClassNameTEXTS.classNameNAME}>
					{
						(data?.subTitle?.isActive && getText(data?.subTitle, translate))
						|| portal?.council?.name
					}
				</span>


				{/* BUTTON */}
				{data?.button?.isActive && <div className={overrideClassNameBTN.classNameDIV}>
					<SimpleButton
						classNameBTN={overrideClassNameBTN.classNameBTN}
						classNameTXT={overrideClassNameBTN.classNameTXT}
						colors={colors}
						fillMode={false}
						negativeMode={true}
						styleBTN={overrideStyleBTN}
						tag={getText(data?.button, translate)}
						onClick={() => setRouting(data?.button?.value)}
					/>
				</div>}
			</div>
			{/* OPTION BUTTON */}
			{data?.buttonOptions?.isActive && <SimpleButton
				classNameBTN={defaultClassBTNOption.classNameBTN}
				classNameTXT={defaultClassBTNOption.classNameTXT}
				colors={colors}
				negativeMode={true}
				tag={getText(data?.buttonOptions, translate)}
				onClick={() => setOpenMobileMenu(true)}
			/>}
		</div>
	</BgImg>;
}

export default Showcase;
